<template>
  <div v-if="metros.length" class="ui-metro">
    <ui-select
      v-model="currentId"
      :required="required"
      :label="label"
      :options="metros"
      empty-value="Не выбрана"
      placeholder="Выберите станцию метро"
      @change-value="$emit('change', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ui-metro',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    emptyValue: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Станция метро',
    },
    cityId: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    metros: [],
  }),
  computed: {
    ...mapGetters({
      USER_CITY: 'user/city',
    }),
    currentId: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  watch: {
    cityId() {
      this.$emit('update:modelValue', '');
      this.metros = [];
      this.loadMetroSpecs();
    },
  },
  created() {
    if ((typeof window === 'undefined')) return;
    this.loadMetroSpecs();
  },
  methods: {
    loadMetroSpecs(cityId = this.cityId) {
      if (cityId === this.USER_CITY.id && !this.USER_CITY.hasMetro) return;
      return this.$store.$api.loadMetroStations({ cityId })
        .then((metros) => {
          this.metros = metros.map((m) => ({ name: m.name, value: m.id }));
        });
    },
  },
};
</script>

<style lang="scss">
.ui-metro {
  position: relative;
}
</style>
